import {
  EMPTY_STRING,
  globalConstants,
  termsAndConditionsConstants,
} from "../../constants";

const { GET_TERMS_AND_CONDITIONS } = termsAndConditionsConstants;
const { SUCCESS } = globalConstants;

const initialState = {
  termsAndConditions: EMPTY_STRING,
};

export const termsAndConditionsReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_TERMS_AND_CONDITIONS + SUCCESS:
      return { ...state, termsAndConditions: action.data };
    default:
      return { ...state };
  }
};
